// this is compiled by parcel with
// `npm run build` or `npm run dev`

import lozad from 'lozad';

jQuery(document).ready(function ($){
    const observer = lozad();
    observer.observe();
});


import './style.scss';